<template>
    <Login :mode="'global'" />
</template>

<script>
import Login from '@root/lk/mapp/Login.vue';

export default { 
    data() { 
        return {
            xxx: "yyy"            
        }        
    },
    props: ["baseData"],
    provide() {
        return {
            baseData: this.baseData,
        };
    },
    components: {
        Login,
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style  lang="sass" scoped>
@import common
@charset "utf-8"

</style>